module.exports = __webpack_public_path__ + "img/77.8318e4bd.jpg";